import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent, ModalController } from '@ionic/angular';
import { AgentClientService, TermsOfUse, TermsOfUseDocumentType } from 'src/app/client/agent-client';


/** Detecta marcacao HTML no conteudo do termo. */
const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i;
@Component({
    selector: 'app-policy',
    templateUrl: './policy.page.html',
    styleUrls: ['./policy.page.scss'],
    standalone: false
})
export class PolicyModal implements OnInit, AfterViewInit {
  @ViewChild(IonContent) content?: IonContent;

  @Input() documentType: TermsOfUseDocumentType = 'USER_COMMERCIAL_APP';
  @Input() term?: TermsOfUse;
  @Input() readonly = true;

  loading = false;
  accepting = false;
  canAccept = false;
  errorMessage = '';

  constructor(
    private modalController: ModalController,
    private agentClientService: AgentClientService,
  ) { }

  get title(): string {
    return this.term?.title || this.getDocumentTitle(this.documentType);
  }

  /**
   * O conteudo e HTML? O painel salva o termo com marcacao, mas documentos
   * antigos podem ter sido colados como texto puro — nesse caso o <pre> preserva
   * as quebras de linha, que o innerHTML colapsaria.
   *
   * O innerHTML do Angular sanitiza por padrao: script e atributos de evento sao
   * removidos antes de chegar na tela.
   */
  get isHtmlContent(): boolean {
    return HTML_TAG_PATTERN.test(`${this.term?.content || ''}`);
  }

  ngOnInit(): void {
    if (this.term) {
      return;
    }
    this.loadActiveDocument();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.updateCanAccept());
  }

  async close(result = false) {
    await this.modalController.dismiss(result);
  }

  onScroll(): void {
    if (this.readonly) {
      return;
    }
    this.updateCanAccept();
  }

  accept(): void {
    if (this.readonly || this.accepting || !this.canAccept || !this.term) {
      return;
    }

    this.accepting = true;
    this.agentClientService.acceptActiveTermsOfUse(this.term.documentType).subscribe({
      next: () => {
        this.accepting = false;
        this.close(true);
      },
      error: () => {
        this.accepting = false;
        this.errorMessage = 'Não foi possível registrar o aceite. Tente novamente.';
      },
    });
  }

  private loadActiveDocument(): void {
    this.loading = true;
    this.errorMessage = '';
    this.agentClientService.getActiveTermsOfUse(this.documentType).subscribe({
      next: (term) => {
        this.term = term;
        this.loading = false;
        setTimeout(() => this.updateCanAccept());
      },
      error: () => {
        this.loading = false;
        this.errorMessage = 'Documento indisponível no momento.';
      },
    });
  }

  private async updateCanAccept(): Promise<void> {
    if (this.readonly || !this.content) {
      return;
    }

    const scrollElement = await this.content.getScrollElement();
    const scrollEnd = scrollElement.scrollTop + scrollElement.clientHeight;
    this.canAccept = scrollEnd >= scrollElement.scrollHeight - 12;
  }

  private getDocumentTitle(documentType: TermsOfUseDocumentType): string {
    if (documentType === 'PRIVACY_POLICY_APP') {
      return 'Política de Privacidade';
    }
    if (documentType === 'USER_VOLUNTEER_POLITICS_APP') {
      return 'Termo do Usuário Voluntário';
    }
    return 'Termo do Usuário';
  }
}
